module.exports = __webpack_public_path__ + "static/media/26UNRWA17.218033b3.jpg";